import Layout from "@/components/Layout";
import GalleryFilter from "@/components/GalleryFilter";

// Converted from gallery.php by scripts/convert-php-pages.mjs.
export default function PageGallery() {
  return (
    <Layout route="/gallery">
      <>
<section>
<div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
<div className="carousel-inner">
<div className="carousel-item active">
<img src="/assets/img/gallerybanner1.jpg" className="d-block w-100" alt="..." />
</div>
<div className="carousel-item">
<img src="/assets/img/gallerybanner1.jpg" className="d-block w-100" alt="..." />
</div>
<div className="carousel-item">
<img src="/assets/img/gallerybanner1.jpg" className="d-block w-100" alt="..." />
</div>
</div>
</div>
</section>
<style dangerouslySetInnerHTML={{ __html: "\r\n    body {\r\n  background-color: #ccdeff;\r\n  font-family: Arial;\r\n}\r\n\r\n/* Center website */\r\n.main {\r\n  max-width: 1000px;\r\n  margin: auto;\r\n}\r\n\r\nh1 {\r\n  font-size: 50px;\r\n  word-break: break-all;\r\n}\r\n\r\n.row {\r\n  margin: 8px -16px;\r\n}\r\n\r\n/* Add padding BETWEEN each column (if you want) */\r\n.row,\r\n.row > .column {\r\n  padding: 8px;\r\n}\r\n\r\n/* Create three equal columns that floats next to each other */\r\n.column {\r\n  float: left;\r\n  width: 33.33%;\r\n  display: none; /* Hide columns by default */\r\n}\r\n\r\n/* Clear floats after rows */\r\n.row:after {\r\n  content: \"\";\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\n/* Content */\r\n.content {\r\n  background-color: white;\r\n  padding: 3px;\r\n}\r\n\r\n/* The \"show\" class is added to the filtered elements */\r\n.show {\r\n  display: block;\r\n}\r\n\r\n/* Style the buttons */\r\n.btn {\r\n  border: none;\r\n  outline: none;\r\n  padding: 12px 16px;\r\n  background-color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Add a grey background color on mouse-over */\r\n.btn:hover {\r\n  background-color: #ddd;\r\n}\r\n\r\n/* Add a dark background color to the active button */\r\n.btn.active {\r\n  background-color: #666;\r\n   color: white;\r\n}\r\n" }} />
<center><h1 style={{ color: "#0843aa", paddingTop: "20px", textShadow: "3px 7px #bbd0f7" }}>Gallery</h1></center>
<section className=" pb-70">
<div className="container">
<GalleryFilter />
<p>Explore Dr. Parveen Yadav's impactful journey as a Minimal Invasive and Robotic Thoracic Onco Surgeon through the captivating photo gallery on Chest Surgery India's website. As a prominent figure in the field, Dr. Yadav actively participates in various events, meetings, and seminars, showcasing the hospital's commitment to cutting-edge thoracic surgery.</p>
<p>
        The gallery provides glimpses into educational conferences, collaborative meetings, and seminars, reflecting Dr. Yadav's dedication to continuous learning and innovation. His involvement underscores Chest Surgery India's focus on staying ahead in medical advancements.
    </p>
<p>
        For those seeking top-notch, patient-centric thoracic care, the gallery is a testament to Dr. Parveen Yadav's expertise and the hospital's commitment to excellence in the specialized field of chest surgery. Witness the impact of his contributions to advancing thoracic surgery at Chest Surgery India.
    </p>

<div className="row">
<div className="column nature">
<div className="content">
<img src="/assets/img/gne3.jpg" alt="Mountains" style={{ width: "100%" }} />
</div>
</div>
<div className="column nature">
<div className="content">
<img src="/assets/img/gne8.jpg" alt="Car" style={{ width: "100%" }} />
</div>
</div>
<div className="column nature">
<div className="content">
<img src="/assets/img/gne1.jpg" alt="Car" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/gne11.jpg" alt="Lights" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/gne7.jpg" alt="Car" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/gne4.jpg" alt="Nature" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting1.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting2.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting3.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting4.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting5.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting6.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting7.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting8.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column cars">
<div className="content">
<img src="/assets/img/meeting9.jpeg" alt="meeting" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/gne13.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/gne10.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/gne9.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/gne12.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/13.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/14.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/15.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/16.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/17.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/17.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/18.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/19.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/20.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/21.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/22.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/23.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/24.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/25.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/26.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/27.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/28.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/29.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/30.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/31.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/32.png" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/chestgallery2.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/chestgallery3.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/chestgallery4.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/chestgallery5.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/chestgallery.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/chestgallery1.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/gallery1.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/gallery2.jpg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/new-img-1.jpeg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/new-img-2.jpeg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/new-img-3.jpeg" alt="People" style={{ width: "100%" }} />
</div>
</div>
<div className="column people">
<div className="content">
<img src="/assets/img/new-img-4.jpeg" alt="People" style={{ width: "100%" }} />
</div>
</div>

</div>


    Read More
    <i className="icofont-long-arrow-right"></i>


<li>
<i className="icofont-calendar"></i>
    Jan 03, 2020
    </li>

</div>





</section>
      </>
    </Layout>
  );
}
